import React from "react";
import { StyleSheet, TouchableOpacity } from "react-native";

import { PdText } from "src/components/layout";
import { useFocusableQuery } from "src/hooks/api";
import { kColors } from "src/kColors";
import { getBrandPublic } from "src/util/apiNew";
import { getSafeUrl } from "src/util/functions";
import { openUrlInNewTab } from "src/util/linking";
import { tBasicBrand } from "tmt_api/src/types/types";

const BrandTermsLink: React.FC<{ brandId?: string }> = ({ brandId }) => {
  const { isLoading, isError, data } = useFocusableQuery<tBasicBrand>(
    React.useCallback(() => getBrandPublic(brandId || ""), [brandId]),
    { enabled: !!brandId },
  );

  if (isLoading || isError || !data?.termsAndConditionsUrl) {
    return null;
  }

  const handleOnPressUrl = async () => {
    openUrlInNewTab(getSafeUrl(data.termsAndConditionsUrl));
  };

  return (
    <TouchableOpacity onPress={handleOnPressUrl}>
      <PdText style={styles.brandTermsLink}>{`${data.name} Terms & Conditions`}</PdText>
    </TouchableOpacity>
  );
};

export default BrandTermsLink;

const styles = StyleSheet.create({
  brandTermsLink: {
    color: kColors.brandPurple,
    textDecorationLine: "underline",
  },
});
